import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '../../services/auth';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login-error',
  imports: [CommonModule],
  templateUrl: './login-error.html',
  styleUrl: './login-error.scss',
})
export class LoginError implements OnInit {
  constructor(private router: Router, private authService: Auth){}
  
  errorMessage: string = 'We were unable to log you in! Session may have expired.';
  btnText: string = 'Login Again';
  loginFeatureEnabled: boolean = environment.loginFeature;

  ngOnInit() {
    const authError = this.authService.getAuthenticationError();
    if (authError !== '') {
      this.errorMessage = authError;
      this.btnText = 'Try Again';
    }
  }

  redirectToLogin() {
    // this.router.navigate(['']);
    window.location.href = '';
  }
}
